export const learn = {
  title: 'Get $50 off your first invoice!',
  note: `Minimum purchase of three 5-gallon bottles and one water dispenser rental required at sign-up.*`,
  showIcon: true,
};

export const validateHeader = {
  title: 'Want $50 off?',
  promoInitiatedTitle: 'Still want $50 off?',
  note: `Just order 3 or more 5-gallon water bottles and a cooler to save $50 on your first invoice.*`,
  showIcon: true,
};

export const validateFooter = {
  title: "YOU'LL NEED TO:",
  notes: ['Add 3 or more bottles', '(and a water dispenser)'],
};

export const termsNote =
  '*Three bottles must be of the same water type. Other terms and conditions apply.';
export const acceptButtonLabel = 'REDEEM';
export const rejectButtonLabel = 'NO THANKS';

export const promoContent = [
  {
    name: 'promo-30',
    bottleCount: 3,
    dispenserCount: 0,
    learn: {
      title: 'Get $30 off your first invoice!',
      note: `Minimum purchase of three 5-gallon bottles required at sign-up.*`,
      showIcon: true,
    },

    validateHeader: {
      title: 'Want $30 off?',
      promoInitiatedTitle: 'Still want $30 off?',
      note: `Just order 3 or more 5-gallon water bottles to save $30 on your first invoice.*`,
      showIcon: true,
    },
    validateFooter: {
      title: "YOU'LL NEED TO:",
      notes: ['Add 3 or more bottles'],
    },
    termsNote:
      '*Three bottles must be of the same water type. Other terms and conditions apply.',
    acceptButtonLabel: 'REDEEM',
    rejectButtonLabel: 'NO THANKS',
  },
  {
    name: 'mover-50',
    bottleCount: 3,
    dispenserCount: 0,
    learn: {
      title: 'Get $50 off your first invoice!',
      note: `Minimum purchase of three 5-gallon bottles required at sign-up.*`,
      showIcon: true,
    },

    validateHeader: {
      title: 'Want $50 off?',
      promoInitiatedTitle: 'Still want $50 off?',
      note: `Just order 3 or more 5-gallon water bottles to save $50 on your first invoice.*`,
      showIcon: true,
    },
    validateFooter: {
      title: "YOU'LL NEED TO:",
      notes: ['Add 3 or more bottles'],
    },
    termsNote:
      '*Three bottles must be of the same water type. Other terms and conditions apply.',
    acceptButtonLabel: 'REDEEM',
    rejectButtonLabel: 'NO THANKS',
  },
  {
    name: 'promo-50',
    bottleCount: 3,
    dispenserCount: 1,
    learn: {
      title: 'Get $50 off your first invoice!',
      note: `Minimum purchase of three 5-gallon bottles and one water dispenser rental required at sign-up.*`,
      showIcon: true,
    },

    validateHeader: {
      title: 'Want $50 off?',
      promoInitiatedTitle: 'Still want $50 off?',
      note: `Just order 3 or more 5-gallon water bottles and a cooler to save $50 on your first invoice.*`,
      showIcon: true,
    },
    validateFooter: {
      title: "YOU'LL NEED TO:",
      notes: ['Add 3 or more bottles', '(and a water dispenser)'],
    },
    termsNote:
      '*Three bottles must be of the same water type. Other terms and conditions apply.',
    acceptButtonLabel: 'REDEEM',
    rejectButtonLabel: 'NO THANKS',
  },
];
